import { render, staticRenderFns } from "./FluxoServicoCemiterais.vue?vue&type=template&id=2cdc1563&scoped=true"
import script from "./FluxoServicoCemiterais.vue?vue&type=script&lang=js"
export * from "./FluxoServicoCemiterais.vue?vue&type=script&lang=js"
import style0 from "./FluxoServicoCemiterais.vue?vue&type=style&index=0&id=2cdc1563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc1563",
  null
  
)

export default component.exports